import { useBrokersServiceBrokersUsersList } from '@insurance/api/queries'
import { BrokerUser } from '@insurance/api/requests'
import { ExportFile } from '@insurance/components'
import { AgentStatuses } from '@insurance/types'
import { TitleSection } from '@shared/components'
import { usePaginationConfig, useQueryUpdate, useSorting } from '@shared/hooks'
import { getFileName } from '@shared/utils'
import { Flex, Space } from 'antd'
import { useTranslation } from 'react-i18next'

import {
  AddAgentButton,
  AgentsFilters,
  AgentsHeader,
  AgentsTable
} from '../components'

type Props = {
  brokerId?: string
}

export const AgentsPage = ({ brokerId }: Props) => {
  const { t } = useTranslation()

  const { params, updateQuery } = useQueryUpdate()
  const { triggerSort, getSortedTableColumns } = useSorting<BrokerUser>()

  const { data, isLoading } = useBrokersServiceBrokersUsersList({
    ...params,
    broker: brokerId,
    ...(params.status !== AgentStatuses.DELETED && {
      excludeStatus: AgentStatuses.DELETED
    })
  })

  return (
    <>
      <TitleSection
        title={t('agents')}
        count={data?.count}
        isLoading={isLoading}
      >
        <AgentsHeader />
      </TitleSection>

      <Flex vertical gap={16}>
        <Flex justify="space-between" gap={16} wrap>
          <AgentsFilters />

          <Space>
            <ExportFile
              url="/brokers/users/xlsx/"
              name={getFileName('customers', 'xlsx')}
              params={{ broker: brokerId }}
            />
            <AddAgentButton brokerId={brokerId} />
          </Space>
        </Flex>

        <AgentsTable
          data={data?.results}
          loading={isLoading}
          triggerSort={triggerSort}
          getSortedTableColumns={getSortedTableColumns}
          pagination={{
            ...usePaginationConfig(data),
            onChange: (page, pageSize) =>
              updateQuery({
                ...params,
                page: page.toString(),
                pageSize: pageSize.toString()
              })
          }}
        />
      </Flex>
    </>
  )
}
